import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MonthlyHoursWorkedChart from "../components/MonthlyHoursWorkedChart";
import MonthlyHoursWorkedSummaryTable from "../components/MonthlyHoursWorkedSummaryTable";
import DateSelector from "../components/DateSelector";
import MonthlyViewLayout from "../components/MonthlyViewLayout";
import { toMonthStart } from "../utils/month";
import { formatLocalDate } from "../utils/localDateTime";

const MonthlyHoursWorkedOverviewPage = () => {
  const { date } = useParams();
  const navigate = useNavigate();
  const rawDate = date || formatLocalDate(new Date());
  const selectedDate = toMonthStart(rawDate);
  const [chartLoading, setChartLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(true);

  // Reset loading states when date changes
  useEffect(() => {
    setChartLoading(true);
    setTableLoading(true);
  }, [selectedDate]);

  useEffect(() => {
    if (!date || date !== selectedDate) {
      navigate(`/chart/monthly/hours-worked/${selectedDate}`, { replace: true });
    }
  }, [date, selectedDate, navigate]);

  const handleDateChange = useCallback((newDate) => {
    navigate(`/chart/monthly/hours-worked/${newDate}`);
  }, [navigate]);

  // Check if any data is still loading
  const isAnyLoading = chartLoading || tableLoading;

  return (
    <MonthlyViewLayout date={selectedDate}>
      <DateSelector date={selectedDate} setDate={handleDateChange} disabled={isAnyLoading} mode="month" />
      <MonthlyHoursWorkedChart date={selectedDate} onLoadingChange={setChartLoading} />
      <MonthlyHoursWorkedSummaryTable date={selectedDate} onLoadingChange={setTableLoading} />
    </MonthlyViewLayout>
  );
};

export default MonthlyHoursWorkedOverviewPage;
